const backendUrl = `https://stagingracingcalendar.org/api`;

// SwaggerUI Documentation URL
// Leave black if documentation should be hidden
//const apiDocumentationUrl = `/documentation`;
const apiDocumentationUrl = ``;

/**
 * Frontend URL.
 */
const frontendUrl = {  
  host: 'stagingracingcalendar.org',
  protocol: 'https',
};

const clubWithMenuAndFooter = "oakcliff"

const tenantsWithoutContactForm = ""

const tenantsWithDownloadTemplate = "oakcliff"

/**
 * Tenant Mode
 * multi: Allow new users to create new tenants.
 * multi-with-subdomain: Same as multi, but enable access to the tenant via subdomain.
 * single: One tenant, the first user to register will be the admin.
 */
const tenantMode = 'multi-with-subdomain';

const requireAuthForPublicPages = true;

export default {
  frontendUrl,
  backendUrl,
  apiDocumentationUrl,
  tenantMode,
  clubWithMenuAndFooter,
  tenantsWithoutContactForm,
  tenantsWithDownloadTemplate,
  requireAuthForPublicPages,
};
